"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BandLetterRange = void 0;
const MGRSConstants_1 = require("../MGRSConstants");
const MGRSUtils_1 = require("../MGRSUtils");
const GridZones_1 = require("./GridZones");
/**
 * Band Letter Range
 */
class BandLetterRange {
    /**
     * Constructor
     *
     * @param south
     *            southern band letter
     * @param north
     *            northern band letter
     */
    constructor(south = MGRSConstants_1.MGRSConstants.MIN_BAND_LETTER, north = MGRSConstants_1.MGRSConstants.MAX_BAND_LETTER) {
        this.south = south;
        this.north = north;
        this.letter = south;
    }
    /**
     * Get the southern band letter
     *
     * @return southern band letter
     */
    getSouth() {
        return this.south;
    }
    /**
     * Set the southern band letter
     *
     * @param south
     *            southern band letter
     */
    setSouth(south) {
        this.south = south;
    }
    /**
     * Get the northern band letter
     *
     * @return northern band letter
     */
    getNorth() {
        return this.north;
    }
    /**
     * Set the northern band letter
     *
     * @param north
     *            northern band letter
     */
    setNorth(north) {
        this.north = north;
    }
    /**
     * Get the southern latitude
     *
     * @return latitude
     */
    getSouthLatitude() {
        return GridZones_1.GridZones.getLatitudeBand(this.south).getSouth();
    }
    /**
     * Get the northern latitude
     *
     * @return latitude
     */
    getNorthLatitude() {
        return GridZones_1.GridZones.getLatitudeBand(this.north).getNorth();
    }
    next() {
        if (this.letter <= this.north) {
            const currentLetter = this.letter;
            this.letter = MGRSUtils_1.MGRSUtils.nextBandLetter(this.letter);
            return {
                done: false,
                value: currentLetter,
            };
        }
        else {
            return {
                done: true,
                value: null,
            };
        }
    }
    reset() {
        this.letter = this.south;
    }
    [Symbol.iterator]() {
        return this;
    }
}
exports.BandLetterRange = BandLetterRange;
//# sourceMappingURL=BandLetterRange.js.map